import { render, staticRenderFns } from "./FontFamilySelector.vue?vue&type=template&id=6a295e5f&"
import script from "./FontFamilySelector.vue?vue&type=script&lang=js&"
export * from "./FontFamilySelector.vue?vue&type=script&lang=js&"
import style0 from "./FontFamilySelector.vue?vue&type=style&index=0&id=6a295e5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports